<template>
  <div class="flex justify-center">
    <button
      class="nav-button"
      @click="scrollLeft"
      :disabled="currentIndex === 0"
      style="margin-right: 16px"
    >
      <el-icon><ArrowLeftBold /></el-icon>
    </button>
    <button
      class="nav-button"
      @click="scrollRight"
      :disabled="currentIndex >= listLength - visibleBoxes"
    >
      <el-icon><ArrowRightBold /></el-icon>
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  listLength: {
    type: Number,
    default: 0,
  },
  visibleBoxes: {
    type: Number,
    default: 4,
  },
});
console.log('props',props)


const currentIndex = defineModel(0);

const scrollRight = () => {
  if (currentIndex.value < props.listLength - props.visibleBoxes) {
    currentIndex.value++;
  }
};

const scrollLeft = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
};
</script>

<style lang="scss" scoped>
.nav-button {
  margin-top: 2rem;
  width: 3.4375rem;
  height: 3rem;
  background-color: #fff;
  border: none;
  border-radius: 0.5px;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #32A89E;
}

.nav-button:disabled {
  color: #bbbbbb;
  cursor: not-allowed;
}

.nav-button:not(:disabled):hover {
  color: #32A89E;
}
</style>
